import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    generalLayout: {
        padding: "0 5%",
    },
    increaseTopSpace: { marginTop: 105 },
    addMarginTopToVerticalTab: {
        "& .MuiPaper-root": { top: 111 },
    },
    addMarginTop: { marginTop: 40 },
    componentsContainer: {
        padding: "100px 0",
        minHeight: "calc(100vh - 328px)",
        boxSizing: "border-box",
    },
    dashboardContainers: {
        margin: "0 60px 60px 120px",
    },
});
